import React, { Component } from 'react';
import { MDBContainer, MDBIframe, MDBCol, MDBBtn } from "mdbreact";

class TrainingMediaView extends Component {
    constructor(props) {
        super(props);
        this.props.loaderOff();

        this.viewMedia = this.viewMedia.bind(this);
    }

    viewMedia = (url) => {
        const { history } = this.props;
        history.push(url)
    }

    render() {
        let url = "https://tupp.tuppafrica.co.za/" + this.props.location.state.folder + "/" + this.props.location.state.mediaId + "." + this.props.location.state.extension
        return (

            <MDBContainer className="text-center">
                <MDBIframe src={url} />

                <MDBCol style={{ textAlign: 'left', marginTop: '5%' }}>
                    {
                        <MDBBtn onClick={() => this.viewMedia(this.props.location.state.navigate)}>Go Back</MDBBtn>
                    }
                </MDBCol>
            </MDBContainer>
        );
    }
}

export default TrainingMediaView;